export default __webpack_public_path__ + "maps-examples-shape-collection-thumbnail-480-635d91a97dfd6754d0d983bcef24f6a1.png";